<template>
	<div>
		<hy-check></hy-check>
	</div>
</template>
<script>
	import hyCheck from './../components/hy-checkss/index.vue'
	export default {
		data() {
			return {};
		},
		mounted() {

		},
		methods: {

		},
		computed: {},
		watch: {},
		components: {
			hyCheck
		},
		updated() {},
		created() {}
	};
</script>
<style>

</style>
